import { FormulaRow } from "./formula-row";
import {ComponentItems} from "./component-Items";

export class ComponentFormulas extends ComponentItems {
  public formulaRows: FormulaRow[] = [];
}
